var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"LqUy3ofVSTsvz5CspnL6C"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["next-candidate-app@toggl-inc"]={id:"LqUy3ofVSTsvz5CspnL6C"};
      